import { 
  platformModuleslist,
  getModuleAnalyticsSettings,
  getStatusList
} from '@/api/analyticsSettings'

export const dashboardStatsMixins = {
  created () {
    this.customer_id = localStorage.getItem('customer_id')
    this.getModuleListForStats()
  },
  data () {
    return {
      customer_id: null,
      moduleListForStats: [],
      stats: []
    }
  },
  methods: {
    async getModuleListForStats () {
      try {
        const { data } = await platformModuleslist()
        this.moduleListForStats = data.data.modules_list.map(element => {
          if (element.platform_modules_id === 15) {
            return {
              ...element,
              module_name: 'Rooms'
            }
          } else if (element.platform_modules_id === 44) {
            return {
              ...element,
              module_name: 'Inventory'
            }
          } else {
            return {
              ...element
            }
          }
        })
      } catch (e) {
        //console.log(e)
      }
    },
    async getModuleStatSettings () {
      this.statCreationPayload.is_enabled = null
      this.statCreationPayload.parent_option_id = null
      this.statCreationPayload.option_id = null
      this.statCreationPayload.price_range = [100, 500]

      try {
        const response = await getModuleAnalyticsSettings(this.statCreationPayload.module_id, this.customer_id, 1)
        this.stats = response.data.data.analytics_options
      } catch (e) {
        //console.log(e)
      }
    },
    async getStatusList (option) {
      try {
        const response = await getStatusList(this.customer_id, this.statCreationPayload.parent_option_id)
        this.statCreationPayload.option_id = null
        option.project_status_list = response.data.data.project_status
      } catch (e) {
        //console.log(e)
      }
    }
  }
}